import { ProfileType } from '@app-types/User';
import { getServiceAxios } from '@utils/ServiceAxiosFactory';

export const getSelf = async (): Promise<ProfileType | null> => {
  try {
    const response = await getServiceAxios().post(
      `${process.env.REACT_APP_USER_SERVICE_URL}/api/v2/users/queries/find-self`,
      {}
    );

    return response.data;
  } catch (err) {
    console.error(err);
    return null;
  }
};
